export enum AnalyticsJourneyKey {
  AppLoad = 'app-load',
}

export enum CommonStep {
  StartJourney,
  EndJourney,
  JourneyFailed,
}

export enum AppLoadStep {
  Authorized = 'Authorized',
  Authenticated = 'Authenticated',
}

export enum CreateCustomerStep {
  CreateCustomer = 'CreateCustomer',
}

export enum ConfirmPackageStep {
  LoadEligiblePackages = 'LoadEligiblePackages',
  AddExtraStream = 'AddExtraStream',
  RemoveExtraStream = 'RemoveExtraStream',
  ConfirmPackage = 'LinkQuote',
}

export enum PaymentStep {
  SelectPayment = 'SelectPayment',
  PaymentSuccess = 'PaymentSuccess',
  PaymentFailed = 'PaymentFailed',
}

export enum JourneyEvent {
  ViewItemList = 'view_item_list',
  SelectItem = 'select_item',
  ViewItem = 'view_item',
  AddToCart = 'add_to_cart',
  SelectAddToCart = 'select_add_to_cart',
  AddToWishlist = 'add_to_wishlist',
  RemoveFromCart = 'remove_from_cart',
  SelectRemoveFromCart = 'select_remove_from_cart',
  ViewCart = 'view_cart',
  SelectViewCart = 'select_view_cart',
  BeginCheckout = 'begin_checkout',
  SelectBeginCheckout = 'select_begin_checkout',
  AddPaymentInfo = 'add_payment_info',
  SelectAddPaymentInfo = 'select_add_payment_info',
  Purchase = 'purchase',
  SelectPurchase = 'select_purchase',
  PaymentFailure = 'payment_failure',
  SelectPaymentFailure = 'select_payment_failure',
  Refund = 'refund',
  EcomJourney = 'ecom_journey',
  SelfServiceJourney = 'selfservice_journey',
}
